export const responseValidator = (params, setStatusService, setIsLoading) => {

    const { response = null, error = {} } = params;

    setIsLoading(false);

    if( response ) {
        return setStatusService(prevState => {
            return {
                ...prevState,
                data: response
            };
        });
    }

    return setStatusService(prevState => {
        return {
            ...prevState,
            error: error
        };
    });
};